import * as React from 'react'
import { useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { H4 } from '../../layouts/TextStyles'
import { StudentAnswer } from '../../pages/student/examPage/components/types'
import { CircularProgress, LinearProgress } from '@mui/material'

interface Props {
    open: boolean
    confirmAction: () => void
    handleClose: () => void
    questions?: any[]
    studentAnswers: StudentAnswer[]
    isFinishing: boolean
    title?: string
    description?: string
}

const FinishExamDialog: React.FC<Props> = ({
    confirmAction,
    open,
    handleClose,
    isFinishing,
    questions,
    studentAnswers,
}) => {
    const { formatMessage } = useIntl()
    const leftQuestions = questions.length - studentAnswers.length

    const renderDialogTitle = () => {
        if (leftQuestions > 0) {
            return (
                <DialogTitle textAlign={'center'}>
                    {formatMessage({ id: 'exam_finish_warning_line_1' })}
                </DialogTitle>
            )
        }

        return (
            <DialogTitle textAlign={'center'}>
                {formatMessage({ id: 'exam_finish_warning_line_3' })}
            </DialogTitle>
        )
    }

    return (
        <Dialog
            maxWidth={'sm'}
            fullWidth
            open={open}
            // onClose={handleClose}
        >
            {renderDialogTitle()}

            {!!leftQuestions && (
                <DialogContent>
                    <DialogContentText textAlign={'center'}>
                        {formatMessage(
                            { id: 'exam_finish_warning_line_2' },
                            { questions: leftQuestions },
                        )}
                    </DialogContentText>
                </DialogContent>
            )}

            <DialogActions sx={{ m: 2, justifyContent: 'center' }}>
                <Button
                    variant="outlined"
                    onClick={handleClose}
                >
                    {formatMessage({ id: 'cancel' })}
                </Button>

                <Button
                    variant="contained"
                    disabled={isFinishing}
                    onClick={() => {
                        confirmAction()
                    }}
                >
                    {formatMessage({ id: 'finish_the_exam' })}

                    {isFinishing && (
                        <CircularProgress
                            size={20}
                            style={{ marginLeft: '8px' }}
                        />
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default FinishExamDialog
